var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    transform: _vm.isAprilFools ? 'scaleX(-1)' : undefined,
  })},[_c('div',{staticStyle:{"width":"100%"}},[_c('NavBar')],1),_c('div',{staticStyle:{"flex":"1","width":"100%","overflow":"auto"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('div',{staticStyle:{"width":"100%"}},[_c('FooterApp')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }